import { useGetApi } from '../shared/hooks/fetchingHooks';
import { PROVIDERS_API_BASE_ROUTE } from './api';

// eslint-disable-next-line import/prefer-default-export
export const useProvidersList = () => useGetApi(PROVIDERS_API_BASE_ROUTE, []);
